import type { AnyRouter } from '@tanstack/react-router'

/** True inside the Android tablet app. The native bridge injects `window.Capacitor`. */
export const isNativeApp = () =>
  !!(window as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.()

/**
 * Android back button: go back in the app, and leave it only from the home screen. Loaded only in
 * the tablet app, so the browser bundle does not carry the plugin.
 */
export async function initNative(router: AnyRouter) {
  if (!isNativeApp()) return
  const { App } = await import('@capacitor/app')
  await App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack && router.state.location.pathname !== '/') router.history.back()
    else void App.minimizeApp()
  })
}
